import * as React from "react";
import * as main from "../../main.module.scss";
import * as intro from "./style.module.scss";
export const Intro = () => {
  return (
    <section className={intro.intro}>
      <div className="container">
        <div className={intro.content}>
          <h2>На марафоне вы:</h2>
          <ul>
            <li>узнаете, как поддерживать свой мозг в тонусе;</li>
            <li>научитесь работать без выгораний и стрессов;</li>
            <li>выполните упражнения  для мозга, которые помогают перезагрузиться и возобновить силы;</li>
            <li>получите рекомендации и бонусы от ведущих экспертов в области интеллектуального развития;</li>
            <li>прокачаете свою интеллектуальную выносливость;</li>
            <li>опробуете на себе упражнения, которые помогут восполнить энергию;</li>
            <li>получите заряд мотивации и рабочие советы, как привить полезные привычки;</li>
            <li>избавитесь от рассеянности.</li>
          </ul><a className={`${main.btn} ${intro.btn}`} href="#order">зарегистрироваться</a>
        </div>
      </div>
    </section>
  );
};
